import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Table as CommonTable } from '../../../../../common/table'
import { Tabs } from '../../../../../common/tabs'
import { getAppendStyleItemWithCustom } from '../../../../../common/tabs/helper'
import {
  getNoDataComponent,
  handleIconDownload,
  renderTd,
  sortKeySchemaTable,
} from '../../helper'
import classes from '../../index.module.scss'
import { TABLE_TABS } from './constant'
import {
  selectByIdTable,
  selectCell,
  selectIdTable,
  selectIndicatorById,
  selectYears,
} from './store/slice'

const Table = ({ isDynamicReport, id, checkTable, tabTable = 0 }) => {
  let ids = useSelector(selectIdTable)
  const years = useSelector(selectYears)

  const [activeTab, setActiveTab] = useState(TABLE_TABS[tabTable].key)

  const tableSchema = {
    UNIT: 'unit',
    RATIO_NAME: 'ratioName',
  }
  years.forEach((year) => (tableSchema[String(year)] = String(year)))

  if (isDynamicReport) {
    ids = ids.filter((id) => checkTable.includes(id))
  }

  const rowIds = ids.filter((id) => TABLE_TABS[activeTab].rowIds.includes(id))

  const isNoData = !years.length

  useEffect(() => {
    handleIconDownload(id, isNoData)
  }, [isNoData])

  if (!years.length) {
    return getNoDataComponent(isDynamicReport)
  }

  return (
    <div className={`flexColumn ${isDynamicReport ? 'px1' : ''}`}>
      {!isDynamicReport && (
        <Tabs
          items={TABLE_TABS}
          isI18n
          activeKey={activeTab}
          onChange={setActiveTab}
          styleContent={{ height: 0 }}
          tabListStyle={{ gap: 0 }}
          getAppendStyleItem={getAppendStyleItemWithCustom()}
        />
      )}
      <div className={`${classes.tablePanelContainer} flex1 minH0`}>
        <CommonTable
          ids={rowIds}
          getDataFromRedux={selectCell}
          isDisplayScroll={!isDynamicReport}
          isNoStickyHead={isDynamicReport}
          schema={sortKeySchemaTable(Object.keys(tableSchema)).map((key) => {
            const title = `financialAnalysis.${key}`
            const colId = tableSchema[key]
            const isYearColumn = !['ratioName', 'unit'].includes(colId)
            return {
              colId,
              title,
              isI18n: true,
              thStyle: {
                marginLeft: !isYearColumn ? '' : 'auto',
                justifyContent: isYearColumn ? 'flex-end' : 'flex-start',
              },
              tdStyle: {
                whiteSpace: isYearColumn ? 'nowrap' : '',
                textAlign: isYearColumn ? 'right' : 'left',
              },
              render: renderTd(selectByIdTable, selectIndicatorById),
            }
          })}
          autoHeightMax={300}
        />
      </div>
    </div>
  )
}

export default Table
